import { CommApiInstance } from "Utils/CommApiInstance";

const TstrApi = async (
    gameSvcCd:string|null,
    tstKindCd:string,
) => {
    const resp = await CommApiInstance.post(`comm/${gameSvcCd}/tstr`,{
        apiBody:{
            tstKindCd:tstKindCd
        }
    });

    const data = resp.data;
    if (data?.apiHdr?.code !== "COMM0000") {
        window.location.href = "/";
        return Promise.reject({
            message: "TSTR validation failed",
            code: data?.apiHdr?.code,
        });
    }

    return data;
}
export default TstrApi;